import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import Address from './address-model'
import {
  CreateAddressAsync,
  DeleteAddressAsync,
  LoadAddresssAsync,
} from './address-thunk'
const initialState: addressSliceState = {
  address: [],
  selected_address: '',
  is_loading_address: false,
  is_creating_address: false,
  is_deleting_address: false,
}
export interface addressSliceState {
  address: Address[]
  selected_address?: string
  is_loading_address: boolean
  is_creating_address: boolean
  is_deleting_address: boolean
}
export const addressSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    setSelectedaddress: (state, action) => {
      state.selected_address = action.payload
    },
    clearStateaddress: (state) => {
      state.address = []
      state.is_loading_address = false
      state.is_creating_address = false
      state.is_deleting_address = false
    },
    mergeaddress: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_address = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.address = merge(state.address, payload) as any
        }
      }
    },

    add_address: (state, action) => {
      if (action.payload) {
        state.address = [...state.address, action.payload]
      }
    },
    set_address: (state, action) => {
      let { key, value, id } = action.payload
      state.address = state.address.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadAddresssAsync.pending, (state) => {
      state.is_loading_address = true
    })
    builder.addCase(LoadAddresssAsync.fulfilled, (state, action) => {
      state.is_loading_address = false
      if (action.payload) {
        state.address = action.payload
      }
    })
    builder.addCase(LoadAddresssAsync.rejected, (state) => {
      state.is_loading_address = false
    })
    builder.addCase(CreateAddressAsync.pending, (state) => {
      state.is_creating_address = true
    })
    builder.addCase(CreateAddressAsync.fulfilled, (state) => {
      state.is_creating_address = false
    })
    builder.addCase(CreateAddressAsync.rejected, (state) => {
      state.is_creating_address = false
    })
    builder.addCase(DeleteAddressAsync.pending, (state) => {
      state.is_deleting_address = true
    })
    builder.addCase(DeleteAddressAsync.fulfilled, (state, action) => {
      state.is_deleting_address = false
      if (state.address) {
        state.address = state.address.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteAddressAsync.rejected, (state) => {
      state.is_deleting_address = false
    })

    builder.addCase(
      autoThunks.CreateItemAddress_byPlayerAsync.pending,
      (state) => {
        state.is_loading_address = true
      },
    )
    builder.addCase(
      autoThunks.CreateItemAddress_byPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_address = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.CreateItemAddress_byPlayerAsync.rejected,
      (state) => {
        state.is_loading_address = false
      },
    )

    builder.addCase(
      autoThunks.UpdateItemAddress_byPlayerAsync.pending,
      (state) => {
        state.is_loading_address = true
      },
    )
    builder.addCase(
      autoThunks.UpdateItemAddress_byPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_address = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.UpdateItemAddress_byPlayerAsync.rejected,
      (state) => {
        state.is_loading_address = false
      },
    )

    builder.addCase(
      autoThunks.DeleteItemAddress_byPlayerAsync.pending,
      (state) => {
        state.is_loading_address = true
      },
    )
    builder.addCase(
      autoThunks.DeleteItemAddress_byPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_address = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.DeleteItemAddress_byPlayerAsync.rejected,
      (state) => {
        state.is_loading_address = false
      },
    )

    builder.addCase(
      autoThunks.GetItemAddress_byPlayerAsync.pending,
      (state) => {
        state.is_loading_address = true
      },
    )
    builder.addCase(
      autoThunks.GetItemAddress_byPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_address = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.GetItemAddress_byPlayerAsync.rejected,
      (state) => {
        state.is_loading_address = false
      },
    )

    builder.addCase(
      autoThunks.GetListAddress_byPlayerAsync.pending,
      (state) => {
        state.is_loading_address = true
      },
    )
    builder.addCase(
      autoThunks.GetListAddress_byPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_address = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.GetListAddress_byPlayerAsync.rejected,
      (state) => {
        state.is_loading_address = false
      },
    )
  },
})

function handleResult(action: any, state: addressSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_address = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.address = merge(state.address, payload) as any
    }
  }
}

export const {
  clearStateaddress,
  setSelectedaddress,
  set_address,
  mergeaddress,
  add_address,
} = addressSlice.actions

export const get_address =
  (id?: string) =>
  (state: {
    address: {
      address: Address[]
    }
  }): Address | null => {
    let temp = state?.address?.address?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.address?.address[0] || null
  }
export const get_selected_address = (state: {
  address: addressSliceState
}): Address | null => {
  let id = state?.address?.selected_address
  let temp = state?.address?.address?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_address = (state: {
  address: {
    address: Address[]
  }
}): Address[] => {
  let temp = state?.address?.address
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_address_busy = (state: { address: addressSliceState }) => {
  return (
    state?.address.is_deleting_address ||
    state?.address.is_loading_address ||
    state?.address.is_creating_address
  )
}
export const is_deleting_address_busy = (state: {
  address: addressSliceState
}) => {
  return state?.address.is_deleting_address
}
export const is_loading_address_busy = (state: {
  address: addressSliceState
}) => {
  return state?.address.is_loading_address
}
export const is_creating_address_busy = (state: {
  address: addressSliceState
}) => {
  return state?.address.is_creating_address
}

export default addressSlice.reducer
